const tables = [
  {
    name: "Number",
  },
  {
    name: "Invoice",
  },
  {
    name: "Customer",
  },
  {
    name: "Date",
  },
  {
    name: "Reason",
  },
  {
    name: "Total",
  },
  {
    name: "Created By",
  },
  {
    name: "Action",
  },
];

export default tables;